module.exports = __webpack_public_path__ + "img/Frame 32.4f6a5a27.png";